import { render, staticRenderFns } from "./DepositCurrenciesNetworksConfiguration.vue?vue&type=template&id=c6070908&"
import script from "./DepositCurrenciesNetworksConfiguration.vue?vue&type=script&lang=js&"
export * from "./DepositCurrenciesNetworksConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VCol,VSwitch})
